var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import styled from "styled-components";
import { variant as variantFn } from "styled-system";
export const StyledText = styled.span.withConfig({ displayName: "StyledText_APC-7311-productShell", componentId: "sc-1coaf13" })(({ theme, color = theme.colors.apolloColorTextPrimary }) => ({
    margin: 0,
    padding: 0,
    color,
}), (props) => {
    return variantFn({
        prop: "$variant",
        variants: props.theme.textStyles,
    });
});
const Text = forwardRef(function Text(_a, ref) {
    var { variant = "body" } = _a, rest = __rest(_a, ["variant"]);
    return React.createElement(StyledText, Object.assign({ ref: ref, "$variant": variant }, rest));
});
export default Text;
//# sourceMappingURL=Text.js.map